import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CARDS_FEATURE_KEY, CardsState } from './cards.reducer';

export const cardsState = createFeatureSelector<CardsState>(CARDS_FEATURE_KEY);

export const customerCards = createSelector(cardsState, (state: CardsState) => state.customerCards);
export const customerCardsLoaded = createSelector(cardsState, (state: CardsState) => state.customerCardsLoaded);
